import { Card, CardContent } from '@/components/ui/card'

interface ScoreCardProps {
  score: number
  label: string
}

export function ScoreCard({ score, label }: ScoreCardProps) {
  return (
    <Card className="p-6 bg-muted/30 rounded-lg border-none shadow-none flex items-center justify-center">
      <CardContent className="pt-0 pb-0">
        <div className="text-center space-y-3">
          <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            {label}
          </div>
          <div className="text-5xl font-bold tracking-tight">
            {score.toFixed(2)}
            <span className="text-2xl ml-1">%</span>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
